import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IBusinessRule } from "./BusinessRule";

export interface TRuleGroupElement {
  id: number;
  displayNumber?: number;
  weightFactor?: number;
  businessRule: IBusinessRule;
}

export interface IRuleGroupElement extends TRuleGroupElement {}

const RuleGroupElement = Model(
  (model: TRuleGroupElement): IRuleGroupElement => {
    const _ruleGroupElement: TRuleGroupElement = Object.assign({}, model);

    let create = (ruleGroupElement: IRuleGroupElement): IRuleGroupElement => {
      let obj = ValidatableObject(ruleGroupElement);
      return obj;
    };

    let businessRule = {
      get id() {
        return _ruleGroupElement.id;
      },
      set id(value) {
        _ruleGroupElement.id = value;
      },
      get businessRule() {
        return _ruleGroupElement.businessRule;
      },
      set businessRule(value) {
        _ruleGroupElement.businessRule = value;
      },

      get displayNumber() {
        return _ruleGroupElement.displayNumber;
      },
      set displayNumber(value) {
        _ruleGroupElement.displayNumber = value;
      },
      get weightFactor() {
        return _ruleGroupElement.weightFactor;
      },
      set weightFactor(value) {
        _ruleGroupElement.weightFactor = value;
      }
    };

    return create(businessRule);
  }
);

export default RuleGroupElement;
